import React, { useContext } from 'react';
import { Accordion, AccordionContext, useAccordionToggle } from 'react-bootstrap';
import { connect } from 'react-redux';
import Layout from '~/Components/Layout/Layout';
import classnames from 'classnames';
import RegisterShortcut from '../../Components/RegisterShortcut/RegisterShortcut';

import "./faq.scss";
import { Link } from 'react-router-dom';
import TextTranslate, { TranslateCMS } from '../../Components/TextTranslate/TextTranslate';

function ContextAwareToggle({ children, eventKey, callback }) {
    const currentEventKey = useContext(AccordionContext);
    const decoratedOnClick = useAccordionToggle(eventKey,() => callback && callback(eventKey));
    const isCurrentEventKey = currentEventKey === eventKey;

    return (
        <div
            className={classnames([
                { expanded: isCurrentEventKey },
                "question",
            ])}
            onClick={decoratedOnClick}
        >
            <h3>{children}</h3>
            <div className="sign"></div>
        </div>
    );
}


const Faq = ({invitation, ...props}) => {

    if (!invitation) {
        return <></>;
    }

    const questions = invitation.event.faqs.map((faq, index) => {
            return {
                title: TranslateCMS({
                    location: invitation.event?.faqs,
                    transId: index,
                    field: 'question',
                    currentLanguage: props.currentLanguage
                }),
                body: TranslateCMS({
                    location: invitation.event?.faqs,
                    transId: index,
                    field: 'answer',
                    currentLanguage: props.currentLanguage
                })
            };
        }
    );

    return (
        <Layout colorBg page="faq">
            <div className="container">
                <div className="row mx-auto text-center text-limit">
                    <h2 className="mb-2 w-100"><TextTranslate name="faq-faq-title" fallback="Frequently Asked Questions"/></h2>
                    <p><TextTranslate name="faq-description-text" fallback="Find the answers to your most common questions below. If you cannot find what you need, feel free to send us an email at"/> <a href="mailto:NEOMexperiences@csm.com" className="link text-primary">NEOMexperiences@csm.com</a>.</p>
                </div>
                <Accordion className="questions">
                    {questions.map((question, index) => {
                        return (
                            <ContextAwareToggle key={`question_${index+1}`} eventKey={index+1}>
                                {question.title}
                                <Accordion.Collapse eventKey={index+1}>
                                    <p>{question.body}</p>
                                </Accordion.Collapse>
                            </ContextAwareToggle>
                        )
                    })}
                </Accordion>
                <div className="row mx-auto text-center text-limit">
                    <h3 className="mb-2 w-100"><TextTranslate name="faq-footer-title" fallback="Did not find what you were looking for?"/></h3>
                    <p><TextTranslate name="faq-footer-description"/></p>
                </div>
            </div>

            <RegisterShortcut />
        </Layout>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations.currentLanguage,
    auth: state.auth,
    invitation: state.invitation.data,
});

export default connect(mapStateToProps)(Faq);
